module.exports = __webpack_public_path__ + "img/domestic_helper.48e95f47.svg";